module.exports = __webpack_public_path__ + "img/seaPalace-3.5caf33ca.jpg";